// @flow
import React from "react";
import {
  SelecaoAjusteDias,
  SelecaoCasasDecimais,
  SelecaoPeriodo,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarAcoesPontualDiario = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);

    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
);

export default function AcoesPontualDiario() {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      <SelecaoAjusteDias />
      {!modoSeries && <SelecaoCasasDecimais />}
    </>
  );
}
